<template>
  <div>

    <!-- Nueva barra de navegación superior -->
    <nav class="navbar-custom">
      <div class="navbar-left">
        <button @click="irFormulario" class="back-button">
          <i class="fas fa-arrow-left"></i>
        </button>
        <h4 class="navbar-title">Crear nueva</h4>
      </div>
    </nav>
    <!-- Contenedor existente --> 
    <div class="container mt-5 text-center">
      <h2 class="text-light">Mi Tabla de Quesos</h2>
      <p>Mi tabla de quesos está concursando en kroonmaridaje.com.</p>
      <p style="font-size: 1.2rem; color: #ffffff;"> ¿Me ayudas promoviéndola en tus redes?</p>

      <!-- Mostrar la imagen generada usando directamente el uuid o desde Strapi -->
      <div v-if="imagenUrl">
        <img :src="imagenUrl" alt="Tabla generada" class="img-fluid mt-4" style="border-radius: 10px;">
      </div>

      <p class="leyenda-ia">Generado en kroonmaridaje.com con IA</p>

      <!-- Mostrar la descripción de la tabla -->
      <div v-if="ingredientes.descripcion" class="descripcion-tabla mt-3">
        <p class="text-light">{{ ingredientes.descripcion }}</p>
      </div>

      <!-- Llamada a la acción -->
      <div class="row mt-3">
        <div class="col-md-12">
          <button @click="compartirTabla" class="btn btn-warning w-100">
            Compartir  <i class="fas fa-share-alt"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { SparklesIcon } from '@heroicons/vue/outline';

export default {
  props: ['uuid'],
  data() {
    return {
      imagenUrl: '',
      ingredientes: {}, // Inicializar ingredientes como un objeto vacío por defecto
    };
  },
  mounted() {
    // Cargar los datos desde Strapi usando el UUID
    this.obtenerIngredientesYImagen();
  },
  components: {
    SparklesIcon
  },
  methods: {
    irFormulario() {
      this.$router.push({ name: 'formulario' });
    },
    compartirTabla() {
      const url = `${window.location.origin}/tabla/${this.uuid}`;
      
      if (navigator.share) {
        navigator.share({
          title: 'Tabla de quesos Kroon',
          text: 'Esta tabla de quesos está concursando en kroonmaridaje.com. ¿Me ayudas promoviéndola en tus redes sociales?',
          url: url
        }).then(() => {
          console.log('Tabla compartida con éxito');
        }).catch(err => {
          console.log('Error al compartir:', err);
        });
      } else {
        alert('Tu navegador no soporta la funcionalidad de compartir.');
      }
    },
    obtenerIngredientesYImagen() {
      // Llamada a la API de Strapi para obtener los ingredientes de la tabla
      const headers = new Headers({
        'Authorization': `Bearer ${process.env.VUE_APP_STRAPI_READ_TOKEN}`,
        'Content-Type': 'application/json'
      });

      fetch(`${process.env.VUE_APP_API_URL}/tablas?filters[uuid_imagen][$eq]=${this.uuid}&populate=imagenes`, { headers })
        .then(response => response.json())
        .then(data => {
          if (data && data.data && data.data.length > 0) {
            const tabla = data.data[0];

            // Verificar si los ingredientes existen antes de asignarlos
            if (tabla.ingredientes) {
              this.ingredientes = tabla.ingredientes;
            } else {
              console.error('No se encontraron ingredientes para el UUID proporcionado');
            }

            // Verificar si hay imágenes disponibles y asignamos la URL correcta desde Strapi
            const imagenes = tabla.imagenes?.[0]; // Tomar la primera imagen si está disponible
            if (imagenes && imagenes.formats && imagenes.formats.large) {
              this.imagenUrl = `${process.env.VUE_APP_IMAGE_URL}${imagenes.formats.large.url}`; // Tomar el formato "large"
            } else if (imagenes && imagenes.url) {
              // Si no existe el formato 'large', usar la imagen original
              this.imagenUrl = `${process.env.VUE_APP_IMAGE_URL}${imagenes.url}`;
            } else {
              console.error('No se encontraron imágenes para el UUID proporcionado');
            }
          } else {
            console.error('No se encontraron datos para el UUID proporcionado');
          }
        })
        .catch(error => {
          console.error('Error al obtener los datos de Strapi:', error);
        });
    }
  }
};
</script>

<style scoped>
.sparkles-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.container {
  background-color: #2c2c2c;
  padding: 20px;
  border-radius: 10px;
}
.img-fluid {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
}
.text-light {
  color: #fff;
}

/* Nueva barra de navegación superior */
.navbar-custom {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  background-color: #181818;
  color: #fff;
  border-bottom: 1px solid #444;
  margin-bottom: 20px; /* Separación del contenido principal */
}

.navbar-left {
  display: flex;
  align-items: center;
}

.back-button {
  background: none;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
  margin-right: 10px;
}

.navbar-title {
  font-size: 1.5rem;
  margin: 0;
}

/* Lista de ingredientes */
.ingredientes-lista {
  text-align: left;
  margin: 0 auto;
  color: #ffffff;
  max-width: 70%;
}

.ingredientes-lista ol {
  margin: 0 auto;
  list-style-type: decimal;
  padding-left: 20px;
  margin-bottom: 30px;
}

.ingredientes-lista li {
  margin-bottom: 0px;
}
.call-to-action {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0px;
  margin-top: 20px;
} 
</style>
